/* eslint-disable */
<template>
  <div class="hours-booked">
    <AdminNavigation ref="navigation" indexProps="6" />
    <div class="top-panel no-sub-title">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Number of Hours of Appointments Booked by Location ({{ totalHours }})</h1></div>
      </div>
    </div>
    <div class="panel no-sub-title">
      <AdminReportsMenu indexProps="5" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <v-md-date-range-picker @change="changeDateRange" class="mr-3"></v-md-date-range-picker>
            <download-csv :data="getCalendarData()" :name="getFileName()">
              <v-btn dark>CSV <img src="@/assets/images/download_light_icon.svg" class="ml-3" /></v-btn>
            </download-csv>
            <!-- <v-btn @click="getCalendarData()">test</v-btn> -->
          </div>
        </div>

        <div class="content-scroll-x">
          <div>
            <div>
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 30%" class="long-text">Location</th>
                    <th style="width: 30%" class="long-text">Month</th>
                    <th style="width: 20%" class="long-text">
                      Number of Bookings
                    </th>
                    <th style="width: 20%" class="long-text">
                      Number of Hours
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div
              :key="allHoursFiltered.length"
              :class="allHoursFiltered.length > 5 ? 'content-scroll-y' : ''"
            >
              <table class="table">
                <tbody>
                    <tr v-for="(hour, key) in allHoursFiltered" :key="key">
                      <td style="width: 30%" class="padded-cell">{{ hour.regionName }}</td>
                      <td style="width: 30%">{{ hour.groupingDate }}</td>
                      <td style="width: 20%">{{ hour.numberOfBookings }}</td>
                      <td style="width: 20%">{{ hour.bookedHours }}</td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities";
import AdminNavigation from "@/components/AdminNavigation";
import AdminAvailabilityMenu from "@/components/AdminAvailabilityMenu";
import Header from "@/components/Header";
import AdminReportsMenu from "@/components/AdminReportsMenu";

export default {
  name: "AdminHoursBookedByLocation",
  components: {
    AdminNavigation,
    AdminAvailabilityMenu,
    Header,
    AdminReportsMenu,
  },
  data() {
    return {
      hasError: false,
      successMessage: "",
      errorMessage: "Please correct the errors shown above and try again.",
      hoursBooked: {},
      limit: 20,
      allHoursBooked: {},
      allHoursUnfiltered: [],
      allHoursFiltered: [],
      errorMessage: "",
      successMessage: "",
      totalHours: 0,
    };
  },
  methods: {
    async loadData(startDate = "", endDate = "") {
      //   var locations = await utilities.getLocations()
      if (startDate == "" || startDate == endDate)
        this.allHoursUnfiltered = await utilities.getReportHoursBookedByLocation(
          moment().format("YYYY-MM-DD"),
          moment().add(1, "y").format("YYYY-MM-DD")
        );
      else
        this.allHoursUnfiltered = await utilities.getReportHoursBookedByLocation(
          startDate,
          endDate
        );
      this.allHoursFiltered = this.allHoursUnfiltered;
      var allHoursBooked = {};
      this.allHoursFiltered.map((x) => {
        this.totalHours += parseFloat(x.bookedHours);
      });
      this.allHoursBooked = allHoursBooked;
      for(var key in this.allHoursBooked) {
        this.allHoursBooked[key].hoursBooked = this.allHoursBooked[key].hoursBooked.sort((a,b) => {
          return moment("01 "+a.groupingDate).isBefore(moment("01 "+b.groupingDate)) ? -1 : 1
        })
      }
      this.hoursBooked = this.allHoursBooked;
    },

    getFileName() {
      return "Hours_booked_" + moment().format("YYYYMMDDHHmm") + ".csv";
    },

    getCalendarData() {
      var calendarData = [];
      this.allHoursFiltered.forEach((hour) => {
        calendarData.push({
          Region: hour.regionName,
          "Month/Date": hour.groupingDate,
          "Number of Bookings": hour.numberOfBookings,
          "Number of Hours": hour.bookedHours,
        });
      })
      return calendarData;
    },

    async changeDateRange(values) {
      this.$store.dispatch("loading/setLoadComponent", true);
      var commencingDate = values[0];
      var endingDate = values[1];
      await this.loadData(
        commencingDate.format("YYYY-MM-DD"),
        endingDate.format("YYYY-MM-DD")
      );
      this.$store.dispatch("loading/setLoadComponent", false);
    },
  },
  async beforeMount() {
    this.$store.dispatch("loading/setLoadComponent", true);
    await this.loadData();
    this.$store.dispatch("loading/setLoadComponent", false);
  },
  mounted() {},
};
</script>
